import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { configureApi } from './composables/useApi';
import { $error } from './composables/useNotify';
import { getWhoAmI } from './composables/useAuth';

import './assets/css/main.css';

configureApi({
  prefix: '/api',
  apiKey: window.localStorage.getItem(import.meta.env.VITE_LOCALSTORAGE_KEY_NAME + '_api_key'),
  // eslint-disable-next-line no-alert
  onError: (details, result) => ($error ? $error('Error', result?.error || details || 'Server error') : alert(result?.error || details || 'Server error'))
});

await getWhoAmI();

createApp(App)
  .use(router)
  .mount('#app');
